/* eslint-disable @typescript-eslint/no-use-before-define */
import * as React from 'react';
import { Button, CheckBox, Modal, ReactSelect } from '../..';
import { Country } from '../../../context/storeContext';
import countries from '../../../utils/countries';
import env from '../../../utils/env';
import { Option } from '../../Inputs/SelectInput/SelectInput';

type ModalProps = {
  onCloseModal: () => void;
  onSelectedCountry: (country: Country, dontAskAgain: boolean) => void;
  defaultCountry: {
    label: string;
    value: string | number;
  };
};

function CountryPrompt({
  onCloseModal,
  onSelectedCountry,
  defaultCountry,
}: ModalProps) {
  const [selectedCountry, setSelectedCountry] = React.useState<Country>();
  const [dontAskAgain, setDontAskAgain] = React.useState(false);
  const [qCountry, setQCountry] = React.useState<{
    label: string;
    value: string | number;
  }>(defaultCountry);

  const supportCountries = env('POS_SUPPORTED_COUNTRIES') || '';

  React.useEffect(() => {
    const country = countries.find(
      fndCountry => fndCountry.iso === defaultCountry.value,
    );

    if (country) {
      const fndCountry = {
        ...country,
        currency:
          supportCountries.includes(country.iso) && country.currency
            ? country.currency
            : 'USD',
        currencySymbol:
          supportCountries.includes(country.iso) && country.currency_symbol
            ? country.currency_symbol
            : '$',
      } as Country;

      setSelectedCountry(fndCountry);
    }
  }, [defaultCountry, supportCountries]);

  const handleOnSelectedCountry = (option: Option) => {
    setQCountry(option);

    const country = countries.find(
      fndCountry => fndCountry.iso === option.value,
    );

    if (country) {
      const fndCountry = {
        ...country,
        currency:
          supportCountries.includes(country.iso) && country.currency
            ? country.currency
            : 'USD',
        currencySymbol:
          supportCountries.includes(country.iso) && country.currency_symbol
            ? country.currency_symbol
            : '$',
      } as Country;

      setSelectedCountry(fndCountry);
    }
  };

  const handleContinue = () => {
    if (selectedCountry) {
      onSelectedCountry(selectedCountry, dontAskAgain);
    }
    onCloseModal();
  };

  return (
    <Modal onClose={onCloseModal} show onHide={() => false}>
      <div className="rounded-md bg-white tablet:w-[500px]">
        <div className="flex flex-col p-5">
          <h3
            className="text-pos-black text-[20px] font-semibold mb-2
              inline-flex whitespace-pre"
          >
            Please confirm your country
          </h3>
          <p className="text-pos-black text-base font-normal">
            Select a country to load the right plan price
          </p>

          <div className="mt-2 mb-3">
            <label htmlFor="supplierId" className="text-xbase block mb-1">
              Country
            </label>
            <ReactSelect
              name="categoryId"
              id="categoryId"
              noOptionsMessage={() => 'No country found!'}
              value={qCountry || ''}
              isClearable
              onChange={handleOnSelectedCountry}
              options={countries.map(fndCountry => ({
                value: fndCountry.iso,
                label: `${fndCountry.flag} ${fndCountry.name}`,
              }))}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{
                menuPortal: (provided: any) => ({
                  ...provided,
                  zIndex: 9999,
                }),
                menu: (provided: any) => ({
                  ...provided,
                  zIndex: 9999,
                }),
              }}
            />
          </div>

          <div className="mt-2">
            <label
              htmlFor="dontShow"
              className="text-xbase mb-1 block pl-[18px] -indent-[18px] cursor-pointer"
            >
              <CheckBox
                id="dontShow"
                name="dontShow"
                value="dontShow"
                checked={dontAskAgain}
                onChange={event => setDontAskAgain(event.target.checked)}
                className="align-middle cursor-pointer"
              />{' '}
              <span className="align-middle">{`Don't ask me again.`}</span>
            </label>
          </div>

          <div className="mt-2 text-center flex flex-row ml-auto space-x-4">
            <Button
              label="Continue"
              onClick={handleContinue}
              type="button"
              className="!bg-pos-green border border-[rgba(27,31,36,0.15)] min-w-[150px]  h-[40px]
                      items-center justify-center text-white text-xbase
                      shadow-[0_1px_0_rgba(27,31,36,0.1),inset_0_1px_0_rgba(255,255,255,0.03)] shrink-0 font-medium"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default CountryPrompt;
